<script setup lang="ts">
import { t } from "@/copy/strings";
import BrandMark from "./BrandMark.vue";
</script>

<template>
  <div class="grid min-h-dvh place-items-center" role="status" aria-live="polite">
    <div class="flex flex-col items-center gap-4 animate-in fade-in duration-500">
      <BrandMark compact class="scale-125" />
      <span class="sr-only">{{ t.common.loading }}</span>
      <div class="h-1 w-24 overflow-hidden rounded-full bg-muted">
        <div class="h-full w-1/3 animate-[slide_1.1s_ease-in-out_infinite] rounded-full bg-primary/70" />
      </div>
    </div>
  </div>
</template>

<style scoped>
@keyframes slide {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(300%);
  }
}
</style>
